import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

import useIntegration from '@hooks/useIntegration'

import IntegrationPlatformLogo from '@components/IntegrationPlatformLogo'

interface IntegrationPlatformProps {
  integrationTitle: string,
  integrationKey: string,
  agency: AgencyModel,
}

const IntegrationPlatform = (props: IntegrationPlatformProps) => {
  const { agency, integrationTitle, integrationKey } = props

  const integrationPayload = useIntegration({
    integrable_id: agency.id,
    integrable_type: 'Agency',
    service_provider: integrationKey,
  })

  const { callbacks: { createOrEditIntegration } } = integrationPayload

  return (
    <Box
      as="a"
      flexDirection="column"
      flexShrink={0}
      marginBottom="large"
      onClick={() => createOrEditIntegration()}
      style={{ cursor: 'pointer' }}
      variant="white"
    >
      <IntegrationPlatformLogo
        imageProps={{
          backgroundSize: 'contain',
          borderRadius: '5px 5px 0 0',
          height: 120,
          width: '100%',
        }}
        integrationPlatformKey={integrationKey}
        size="large"
      />

      <ListItem
        boxProps={{
          alignItems: 'center',
          borderTop: '1px solid',
          padding: 'large',
        }}
        showAngleIcon
      >
        <Box flexDirection="column" justifyContent="center">
          <Text fontSize="small">{integrationTitle}</Text>

          <Box alignItems="center" fontSize="small" marginTop="medium">
            <Text color="bodyFontLightColor">Integration Platform</Text>
          </Box>
        </Box>
      </ListItem>
    </Box>
  )
}

export default IntegrationPlatform
